var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    { attrs: { disabled: _vm.checking } },
    [
      _c(
        "v-expansion-panel",
        { attrs: { id: "summary-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("summary")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewSummary\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    HomeVantage™ Summary\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-summary")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "deal-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("deal")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyReviewLPP\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    Deal Summary\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-deal")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        { attrs: { id: "upfront-mobile-accordion" } },
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "title-branding",
              on: {
                click: function($event) {
                  return _vm.goTo("upfront")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-start align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "" : "primary",
                        large: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyMoreBenefitEstateFee\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h3",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    Upfront Payment\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "no-padding-accordion-panel" },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { flat: "" } },
                [_c("summary-upfront")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.clientView
        ? _c(
            "v-expansion-panel",
            { attrs: { id: "advisor-mobile-accordion" } },
            [
              _c(
                "v-expansion-panel-header",
                {
                  staticClass: "title-branding",
                  on: {
                    click: function($event) {
                      return _vm.goTo("advisor")
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-start align-center" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: _vm.$vuetify.theme.dark ? "" : "primary",
                            large: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                    $mdiLegacyReviewAdvisor\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "h3",
                        {
                          class: _vm.$vuetify.theme.dark
                            ? "white--text"
                            : "primary--text"
                        },
                        [
                          _vm._v(
                            "\n                    Advisor WIIFM\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                { staticClass: "no-padding-accordion-panel" },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-0", attrs: { flat: "" } },
                    [_c("summary-advisor")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }